export const ROUTES = {
  reports: "/reports",
  emailAnalytics: "/email-analytics",
  employeeReports: "/reports/employee/:employeeId",
  locationReports: "/reports/location/:locationId",
  emailLocationAnalytics: "/email-analytics/location/:locationId",
  emailTypeAnalytics: "/email-analytics/type/:typeId",
};

/**
 * Get the actual path by replacing dynamic parameter in the route
 * @param {string} route - The route path with dynamic parameters (e.g. '/reports/employee/:employeeId')
 * @param {string} id - The ID to replace in the path
 * @returns {string} The actual path with parameter replaced
 *
 * Example usage:
 * getRoutePath('/reports/employee/:employeeId', '123') => '/reports/employee/123'
 */
export const getRoutePath = (route, id) => {
  if (!route) {
    console.error("Route path is required");
    return "/";
  }

  let path = route;

  // Simple string replacement for the ID
  if (id !== undefined) {
    path = path.replace(/:\w+/, id);
  }

  return path;
};
